window.addEventListener('load', function() {
    // Sätt flaggan så popupen inte visas
    sessionStorage.setItem("popupShown", "true");

    // Kolla om popupen redan finns och ta bort den direkt
    document.querySelectorAll('iframe').forEach(function(node) {
        if (node.src.includes("ungapped.io")) {
            // Tar bara bort popup-iframe, inte vanliga nyhetsbrev
            if (node.closest('div') && 
                (node.closest('div').style.zIndex === "9999" || node.closest('div').style.zIndex === "9998")
            ) {
                node.closest('div').remove(); // tar bort popupens container
                node.remove(); // tar bort själva iframen
            }
        }
    });

    // Observera DOM för att ta bort popupen direkt om den dyker upp igen
    const observer = new MutationObserver(function(mutationsList) {
        for (const mutation of mutationsList) {
            mutation.addedNodes.forEach(function(node) {
                if (node.tagName === 'DIV' && node.style && 
                    (node.style.zIndex === "9998" || node.style.zIndex === "9999")
                ) {
                    const iframe = node.querySelector('iframe');
                    if (iframe && iframe.src.includes("ungapped.io")) {
                        node.remove(); // ta bort popupen
                    }
                }
            });
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
